module.exports = __webpack_public_path__ + "static/media/TR.ffeaeaa6.svg";